/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UpdateNamespaceRelationshipCardinalityPayload = {
    childNamespaceId: string;
    parentNamespaceId: string;
    cardinality: UpdateNamespaceRelationshipCardinalityPayload.cardinality;
};

export namespace UpdateNamespaceRelationshipCardinalityPayload {

    export enum cardinality {
        SINGLE = 'single',
        MULTIPLE = 'multiple',
    }


}

